var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/arrow-down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 2",
    d: "M21 12.5L3 12.5",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 3",
    d: "M9 6.5L3 12.5L9 18.5",
    stroke: "white",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronWhite);
export default __webpack_public_path__ + "static/media/chevronWhite.07ea7dc06aa124d28120447a973dce54.svg";
export { ForwardRef as ReactComponent };